import { NO_DATA_FALLBACK } from '../configuration';
import { ILxsAnonymousDeliveryResources } from '../modules/lxs-anonymous-delivery/lxs-anonymous-delivery.props.autogenerated';
import { IOrderDetailsResources } from '../modules/order-details/order-details.props.autogenerated';

const isLxsAnonymousDeliveryResources = (
    resources: IOrderDetailsResources | ILxsAnonymousDeliveryResources
): resources is ILxsAnonymousDeliveryResources => 'lxsAnonymousDeliveryStepOrdered' in resources;

export const mapEventNameToText = (eventName: string, resources: IOrderDetailsResources | ILxsAnonymousDeliveryResources): string => {
    if (!eventName) {
        return isLxsAnonymousDeliveryResources(resources) ? NO_DATA_FALLBACK : resources.orderDetailsEventNameUnknown;
    }

    switch (eventName.toLowerCase()) {
        case 'completed':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepDelivered
                : resources.orderDetailsEventNameCompleted;
        case 'ordered':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepOrdered
                : resources.orderDetailsEventNameOrdered;
        case 'in transit':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepInTransit
                : resources.orderDetailsEventNameInTransit;
        case 'planned':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepPlanned
                : resources.orderDetailsEventNamePlanned;
        case 'active':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepActive
                : resources.orderDetailsEventNameActive;
        case 'arrival':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepArrival
                : resources.orderDetailsEventNameArrival;
        case 'container_loading':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepContainerLoading
                : resources.orderDetailsEventNameLoading;
        case 'departure':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepDeparture
                : resources.orderDetailsEventNameDeparture;
        case 'confirmed':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepConfirmed
                : resources.orderDetailsEventNameConfirmed;
        case 'self_pickup':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepSelfPickup
                : resources.orderDetailsEventNameSelfPickup;
        case 'delivered':
            return isLxsAnonymousDeliveryResources(resources)
                ? resources.lxsAnonymousDeliveryStepDelivered
                : resources.orderDetailsEventNameUnknown;
        default:
            return isLxsAnonymousDeliveryResources(resources) ? NO_DATA_FALLBACK : resources.orderDetailsEventNameUnknown;
    }
};
